import { inject, Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';
import { CheckImporterResult } from '../../../../models/check-importer/check-importer.types';
import {
  MCAuthoritiesEventsEconomyUtils,
  MCCheckCommunicationSettlementService,
} from '@maslul/common-services';

@Injectable({
  providedIn: 'root',
})
export class CheckImporterCommunicationService {
  private mcAuthoritiesEventsEconomyUtils = inject(
    MCAuthoritiesEventsEconomyUtils,
  );

  private mcCheckCommunicationSettlementService = inject(
    MCCheckCommunicationSettlementService,
  );

  checkImporterId(
    importId: string,
    message: string,
  ): Observable<CheckImporterResult> {
    return this.mcAuthoritiesEventsEconomyUtils
      .isImporterPalestinian(importId)
      .pipe(
        map((isPalestinain) => {
          const importerResult: CheckImporterResult = new CheckImporterResult();

          if (isPalestinain) {
            importerResult.isValid = false;
            importerResult.message = message;
          } else {
            importerResult.isValid = true;
          }
          return importerResult;
        }),
      );
  }

  checkSettlement(
    settlementId: string,
    errorMessage: string,
  ): Observable<CheckImporterResult> {
    return this.mcCheckCommunicationSettlementService
      .checkSettlement(settlementId)
      .pipe(
        map((isPalestinain) => {
          const importerResult: CheckImporterResult = new CheckImporterResult();

          if (isPalestinain) {
            importerResult.isValid = false;
            importerResult.message = errorMessage;
          } else {
            importerResult.isValid = true;
          }
          return importerResult;
        }),
      );
  }

  checkImporter(args: any): Observable<CheckImporterResult> {
    if (args.importerId) {
      return this.checkImporterId(
        args.importerId,
        args.invalidMsg.palestinianImporterIdCommunication,
      );
    } else if (args.importerSettlementId) {
      return this.checkSettlement(
        args.importerSettlementId,
        args.invalidMsg.palestinianImporterSetlementCommunication,
      );
    } else {
      const importerResult: CheckImporterResult = new CheckImporterResult();
      importerResult.isValid = true;
      return of(importerResult);
    }
  }
}
